<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>Exhibiting</BreadcrumbItem>
            <BreadcrumbItem>Apply for Exhibitor Pass</BreadcrumbItem>
          </Breadcrumb>
          <p style="margin-left: 20px; font-size: 20px; color: red">
          The application process for exhibitor badges is now open.
            <!-- Deadline：June 8, 2025  -->
          </p>
        </div>

        <div class="header-tool-title">{{ exhibition.nameEn }}</div>
      </div>
      <!-- <div class="header-tool-box">
        <div class="htb-item" @click="addShow = true">
          <span class="htb-add">+</span>
          <span>Add Exhibitor Pass</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <!-- <TabPane label="Confirmed" name="1">
          <exhibitionCertYes
            :addShow="addShow"
            @closeModal=" addShow = false; showTabs='2'"
            v-if="String(showTabs) === '1'"
            ref="exhibitionCertYes"
          ></exhibitionCertYes>
        </TabPane>
        <TabPane label="Not reviewed" name="2">
          <exhibitionCertNo
            ref="exhibitionCertNo"
            :addShow="addShow"
            @closeModal=" addShow = false; $refs.exhibitionCertNo.init();"
            v-if="String(showTabs) === '2'"
          ></exhibitionCertNo>
        </TabPane> -->
        <TabPane label="Exhibitor's certificate" name="1">
          <excard v-if="String(showTabs) === '1'"></excard>
        </TabPane>
        <!-- v-if="exhibition.applyForSpecifications != '1'" -->
        <TabPane label="Special guests" v-if="exhibition.applyForSpecifications != '1'"  name="2" >
          <!-- <exhibitionCertNo
            ref="exhibitionCertNo"
            :addShow="addShow"
            @closeModal=" addShow = false; $refs.exhibitionCertNo.init();"
            v-if="String(showTabs) === '2'"
          ></exhibitionCertNo> -->
          <exspecial v-if="String(showTabs) === '2'"></exspecial>
        </TabPane>
        <TabPane label="Overseas/Hong Kong,Macao and TaiWan" name="3" >
          <exhibitionCertEn v-if="String(showTabs) === '3'"></exhibitionCertEn>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapMutations ,mapActions} from "vuex";
import exhibitionCertYes from "./components/exhibition-cert-yes";
import exhibitionCertNo from "./components/exhibition-cert-no";
import excard from "./components/exhibition-card";
import exspecial from "./components/exhibition-special-guests";
import exhibitionCertEn from "./components/exhibition-cret-En";
export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      addShow: false,
      showTabs: "1",
    };
  },
  components: {
    exhibitionCertYes,
    exhibitionCertNo,
    excard,
    exspecial,
    exhibitionCertEn,
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
    }),
  },
 async created() {
    document.title = "中国国际医疗器械博览会 - 证件申请";
       let ex = await this.getExhibitionById(this.exhibition.id);
      this.setExhibition(ex);
  },
  methods: {
            ...mapMutations({
      setExhibition: "loginModule/setExhibition",
    }),
        ...mapActions({

      getExhibitionById: "exhibitionModule/getExhibitionById",
    }),
    switchBrand(name) {},
  },
};
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
  /deep/ {
    .ivu-tabs-tab {
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>
